import React from 'react';
import { ArrowUp, ArrowDown, Minus } from '@phosphor-icons/react';

// Reusable movement chip used by FinalizePreviewDialog, Week N rows, Standings.
// `size` is "sm" (table rows) or "md" (preview/standings).
export default function MovementBadge({ movement, size = 'sm', label }) {
  const dim = size === 'md' ? 16 : 12;
  const base = 'inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[10px] uppercase tracking-wider font-medium';

  if (movement === 'up') {
    return (
      <span data-testid="movement-up" className={`${base} bg-green-100 text-green-800`}>
        <ArrowUp size={dim} weight="bold" /> {label ?? 'Up'}
      </span>
    );
  }
  if (movement === 'down') {
    return (
      <span data-testid="movement-down" className={`${base} bg-red-100 text-red-700`}>
        <ArrowDown size={dim} weight="bold" /> {label ?? 'Down'}
      </span>
    );
  }
  return (
    <span data-testid="movement-stay" className={`${base} bg-[#e3dcd1]/60 text-[#6a766e]`}>
      <Minus size={dim} weight="bold" /> {label ?? 'Stay'}
    </span>
  );
}
